// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3BFl6","spin":"Spinner_spin__3KvE_","container":"Spinner_container__3WJ_z"};